import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import themeConfigSlice from './themeConfigSlice';
import authSlice from './authSlice';
import userDataSlice from './userDataSlice';

const themeConfigPersistConfig = {
    key: 'themeConfig',
    storage,
};

const rootReducer = combineReducers({
    themeConfig: persistReducer(themeConfigPersistConfig, themeConfigSlice),
    auth: authSlice,
    userData: userDataSlice,
});

const persistConfig = {
    key: 'root',
    storage,
    blacklist: ['themeConfig'],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
            },
        }),
});

const persistor = persistStore(store);

export type IRootState = ReturnType<typeof rootReducer>;
export default store;
export { persistor };
